import {useNuxtApp} from 'nuxt/app';
// @ts-ignore
// eslint-disable-next-line
// prettier-ignore
import type { AllTranslationsRecord, SingleParameter, TranslationKey, TupleIndices } from './i18n.types';

type CommonKeyRecord = Record<string, SingleParameter[] | Record<string, any>>;

/**
 * function definition for simple arguments checks, will not report errors when too much arguments are passed
 */
export interface SimpleTypedTFunction<TAllowedKeys extends string, TKeysRecord extends CommonKeyRecord> {
    <TKey extends TAllowedKeys>(
        keyName: TKey,
        ...[params]: TKey extends keyof TKeysRecord
            ? TKeysRecord[TKey] extends [never]
                ? [...any]
                : [
                      TKeysRecord[TKey] extends [...any[]]
                          ? TKeysRecord[TKey] | Record<TupleIndices<TKeysRecord[TKey]>, SingleParameter>
                          : TKeysRecord[TKey],
                  ]
            : [...any]
    ): string;
}

export function useTranslation(): {
    t: SimpleTypedTFunction<TranslationKey, AllTranslationsRecord>;
} {
    // In some contexts (stores or middlewares for instance), we get this error: i18next-vue: No Vue instance in context
    // In that cases, we can fallback to $i18next instance from the Nuxt application

    return useNuxtApp().$i18next as any;
}
